import React, { useState } from 'react';
import { toast } from 'sonner';
import { FileSpreadsheet, FileText, Loader2 } from 'lucide-react';
import { exportWidgetExcel, exportWidgetPdf } from '@/lib/tagWidgetExport';

const BTN = 'inline-flex h-7 items-center gap-1 rounded-lg border border-border bg-background px-2 text-[length:calc(var(--fs,1)*0.6875rem)] font-semibold text-muted-foreground transition-colors hover:border-emerald-600/40 hover:text-emerald-700 disabled:opacity-50 dark:hover:text-emerald-300';

// Excel / PDF buttons on a dashboard widget; get() returns the widget's table, node = area to picture for charts.
export function WidgetExport({ get, node, testid }) {
  const [busy, setBusy] = useState('');
  const run = async (kind) => {
    const data = get();
    if (!data.rows.length) { toast.error('Nothing to export for these filters.'); return; }
    setBusy(kind);
    try { await (kind === 'xl' ? exportWidgetExcel : exportWidgetPdf)(data, data.picture ? node.current : null); }
    catch { toast.error('Could not create the file. Please try again.'); } finally { setBusy(''); }
  };
  return (
    <div className="flex items-center gap-1" data-export-ignore="true">
      <button type="button" disabled={!!busy} onClick={() => run('xl')} title="Download Excel" className={BTN} data-testid={`${testid}-excel`}>{busy === 'xl' ? <Loader2 size={12} className="animate-spin" /> : <FileSpreadsheet size={12} />} Excel</button>
      <button type="button" disabled={!!busy} onClick={() => run('pdf')} title="Download PDF" className={BTN} data-testid={`${testid}-pdf`}>{busy === 'pdf' ? <Loader2 size={12} className="animate-spin" /> : <FileText size={12} />} PDF</button>
    </div>
  );
}
